import { Component, OnInit } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { ActivatedRoute } from '@angular/router';
import { take, map } from 'rxjs/operators';
import { from } from 'rxjs';

@Component({
    selector: 'app-request',
    templateUrl: './request.component.html',
    styleUrls: ['./request.component.scss'],
    standalone: false
})
export class RequestComponent implements OnInit {
  success = false;
  fail = false;
  loadingMessage = "Accepting request..."

  constructor(
    private route: ActivatedRoute,
    private fns: Functions,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.route.queryParamMap.subscribe(qParams => {
        console.log(params.get('reqId'));
        console.log(qParams.get('accept'));

        if(qParams.get('accept')) {
          const acceptRequest = httpsCallable(this.fns, 'acceptRequest');

          from(acceptRequest({
            reqId: params.get('reqId'),
          })).pipe(
            map(result => result.data),
            take(1)
          ).subscribe(res => {
            console.log(res);
            const response = res as any;

            if(response.success) {
              this.success = true;
            }
            else {
              this.fail = true;
            }
          })
        }
      })
    })
  }

}
